/**
 * Fond cliquable d'une fenêtre modale : un vrai bouton (accessible au clavier et aux lecteurs d'écran) qui couvre
 * le calque, plutôt qu'un gestionnaire de souris posé sur une div. La fenêtre se place au-dessus avec
 * `position: "relative", zIndex: 1`.
 */
export default function ModalBackdrop({ onClose }) {
    return (
        <button
            type="button"
            aria-label="Fermer la fenêtre modale"
            onMouseDown={onClose}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", padding: 0, border: 0, background: "transparent", cursor: "default" }}
        />
    );
}
